import script from "./IntrInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IntrInfo.vue?vue&type=script&setup=true&lang=js"

import "./IntrInfo.vue?vue&type=style&index=0&id=511c7b4c&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/spepi.cn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511c7b4c"]])

export default __exports__